// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-info.v-card__text pre,
.center-info pre {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./js/modules/assurance/components/dialogs/Info.vue","webpack://./Info.vue"],"names":[],"mappings":"AAGE;;EACE,gBAAA;ACDJ","sourcesContent":["\n.center-info.v-card__text,\n.center-info{\n  pre {\n    text-align: left;\n  }\n}\n",".center-info.v-card__text pre,\n.center-info pre {\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
